var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-soldOut-icon",class:({      'soldout-activity' :_vm.isActivityOut    })},[_c('div',{staticClass:"header-soldOut-text",class:({          'isEn':_vm.isEn        })},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }